import {IMessage, IMessageType, IRuleset, ISyncstep, TSyncfield} from "../../index";

interface IMessageMutable {
    $original: IMessage
    active: KnockoutObservable<boolean>,
    addrecipient: KnockoutObservable<string>
    body: KnockoutObservable<string>
    description: KnockoutObservable<string>
    messagetype: KnockoutObservable<IMessageType | null>
    name: KnockoutObservable<string>
    recipientfield: KnockoutObservable<string | null>
    ruleset: KnockoutObservable<IRuleset | null>
    sender: KnockoutObservable<string>
    subject: KnockoutObservable<string>
    syncstep: KnockoutObservable<ISyncstep | null>
}

export type TType = 'sms' | 'email' | 'eadm' | 'user' | 'manager' | 'custom' | 'task' | 'message';

export interface IType {
    icon: string
    key: TType
    label: string
    recipientType?: string
}

interface ICustomMessageType {
    $original: IMessageType
    maintype: IType | null,
    subtype: IType | null,
}
